import { Navigate, useRoutes } from 'react-router-dom';
// layouts
//
import UserNewEditForm from 'src/sections/user/user-new-edit-form';
import { mainRoutes, HomePage } from './main';
import { authRoutes } from './auth';
import { authDemoRoutes } from './auth-demo';
import { dashboardRoutes } from './dashboard';
import { componentsRoutes } from './components';
import AuthClassicLayout from '../../layouts/auth/classic';
import LoginPage from "../../pages/auth/jwt/login";

// ----------------------------------------------------------------------

export default function Router() {
  const userId = localStorage.getItem('QRId');
  const UserCd = localStorage.getItem('Hsp');
 

  const loginRoutes = [
    {
      path: '/',
      element: (
        <AuthClassicLayout>
          <LoginPage />
        </AuthClassicLayout>
      ),
    },
    {
      path: '/webwork',
      element: (
        <AuthClassicLayout>
          <LoginPage />
        </AuthClassicLayout>
      ),
    },
    {
      path: '/CMMS_KPJ_WEB',
      element: (
        <AuthClassicLayout>
          <LoginPage />
        </AuthClassicLayout>
      ),
    },
  
    ...authRoutes,
    ...mainRoutes,
    ...componentsRoutes,
    { path: '*', element: <Navigate to="/" replace /> },
  ];
  const dashboardRoutesConfig = [
    {
      path: '/',
      element: <Navigate to="/dashboard/work_request/list"/>,
    },
    {
      path: '/dashboard',
      element: userId !== null ? <UserNewEditForm /> : <Navigate to="/login" />,
    },
    ...dashboardRoutes,
    ...mainRoutes,
    ...componentsRoutes,
    { path: '*', element: <Navigate to="/404" replace /> },
  ];

  // Use the appropriate route configuration based on the value of 'vt'
  const routes = userId !== null ? dashboardRoutesConfig : loginRoutes;

  return useRoutes(routes);
  // return useRoutes([
 
  //   // SET INDEX PAGE WITH HOME PAGE
  //   {
  //     path: '/',

  //      element:  <AuthClassicLayout>
  //                  <LoginPage />
  //                </AuthClassicLayout>,
  //     },
  //     {
  //       path: '/webwork',
      
  //        element:  <AuthClassicLayout>
  //                    <LoginPage />
  //                  </AuthClassicLayout>,
  //       },
  //   // Auth routes
  //   ...authRoutes,
  //  // ...authDemoRoutes,
   
  //   // Dashboard routes
  //    ...dashboardRoutes,

  //   // Main routes
  //   ...mainRoutes,

  //   // Components routes
  //   ...componentsRoutes,

  //   // No match 404
  //   { path: '*', element: <Navigate to="/404" replace /> },
  // ]);
}
